export var scrollActions;
(function (scrollActions) {
    scrollActions["SET"] = "composition:list:SET";
    scrollActions["STICKY"] = "composition:list:STICKY";
})(scrollActions || (scrollActions = {}));
